export default "__VITE_ASSET__a760272a__"